import _environmentUserAgent from "../internals/environment-user-agent";
var exports = {};
var userAgent = _environmentUserAgent;
exports = /web0s(?!.*chrome)/i.test(userAgent);
export default exports;